import { ETH_CHAIN_ID } from '@app/config/env'
import { useAccount, useChainId } from 'wagmi'

/** RainbowKit header uses the connected account chain; useChainId can lag on the default PulseChain. */
export function useWalletChainId(): number {
  const { chainId: accountChainId } = useAccount()
  const configChainId = useChainId()
  return accountChainId ?? configChainId
}

export const ETHEREUM_MAINNET_ID = ETH_CHAIN_ID || 1
